import React from 'react';

const SafeIcon = ({ icon: Icon, className = '', ...props }) => {
  if (!Icon) {
    return <div className={`inline-block ${className}`} {...props} />;
  }
  
  return <Icon className={className} {...props} />;
};

export default SafeIcon;